import { Injectable } from '@angular/core';
import { OwnerDataStateService } from './section-services/owner-data/owner-data-state.service';
import { VehicleStateStateService } from './section-services/vehicle-data/vehicle-state-state.service';
import { PartyTypeCode } from '../../consts/party-type-code.enum';
import {isNext} from '../../utils/utils';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {StepKey} from '../../enums/step-key.enum';

@Injectable({
  providedIn: 'root'
})
export class CalculationValidationService {

  isNext = isNext();

  constructor(private ownerDataState: OwnerDataStateService,
              private vehicleStateStateService: VehicleStateStateService) { }

  validateStep(stepKey: string): CalculationDataError[] {
    let errors: CalculationDataError[] = [];
    switch (stepKey) {
      case StepKey.FIRST_STEP_2:
        errors = [this.validateLeasing()];
        break;
      case StepKey.FIRST_STEP_3:
        errors = [
          this.validatePartyTypeCode(),
          this.validatePeselNumbers(),
        ];
        if (this.isNext) {
          errors.unshift(this.validateLeasing());
        }
        break;
    }

    return errors.filter(error => isNotNullOrUndefined(error));
  }

  private validateLeasing(): CalculationDataError | null {
    return this.vehicleStateStateService.isLeasing ? CalculationDataError.UNSUPPORTED_DATA : null;
  }

  private validatePartyTypeCode(): CalculationDataError | null {
    return this.ownerDataState.partyTypeCode === PartyTypeCode.ORGANIZATION ? CalculationDataError.UNSUPPORTED_DATA : null;
  }

  private validatePeselNumbers(): CalculationDataError | null {
    return this.ownerDataState.arePeselNumbersUnique() ? null : CalculationDataError.NOT_UNIQUE_PESEL_NUMBERS;
  }
}

export enum CalculationDataError {
  UNSUPPORTED_DATA = 'UNSUPPORTED_DATA',
  NOT_UNIQUE_PESEL_NUMBERS = 'NOT_UNIQUE_PESEL_NUMBERS'
}
